import { create } from 'zustand'

// Состояние глобального поиска в топбаре. Живёт вне роутера: клик по тег-чипу на
// любой странице (openWithTag) открывает дропдаун в тег-режиме, не уводя со
// страницы. Доска фильтрует иначе — через `?tag=`, не через этот стор.
interface SearchState {
  query: string
  tag: string | null
  open: boolean
  setQuery: (query: string) => void
  /** Открыть дропдаун, отфильтрованный по тегу (клик по чипу вне доски). */
  openWithTag: (tag: string) => void
  setOpen: (open: boolean) => void
  clearTag: () => void
  reset: () => void
}

export const useSearchStore = create<SearchState>((set) => ({
  query: '',
  tag: null,
  open: false,
  setQuery: (query) => set({ query }),
  openWithTag: (tag) => set({ tag, query: '', open: true }),
  setOpen: (open) => set({ open }),
  clearTag: () => set({ tag: null }),
  reset: () => set({ query: '', tag: null, open: false }),
}))
